import { format, parse } from "date-fns";

// Function to convert 12-hour format to 24-hour format
export const convert12To24Hour = (time: string | undefined) => {
  if (!time) return undefined;

  // Parse the time assuming it's in 'h:mm a' (12-hour) format (e.g., 2:30 PM)
  const parsedTime = parse(time, "h:mm a", new Date());

  // Format it to 24-hour format (e.g., 14:30)
  return format(parsedTime, "HH:mm");
};
